export function initMap() {
  document.addEventListener('DOMContentLoaded', function () {

    if (!document.getElementById('contact-map')) return;
    
    // Set your coordinates here
    const lat = 55.757850;
    const lng = 12.502330;
    const zoom = 14;

    const map = L.map('contact-map', {
      scrollWheelZoom: false,
    }).setView([lat, lng], zoom);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    // Custom green marker icon
    const greenIcon = L.divIcon({
      className: 'custom-marker',
      html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="44" viewBox="0 0 32 44">
          <path d="M16 0C7.163 0 0 7.163 0 16c0 10 16 28 16 28s16-18 16-28C32 7.163 24.837 0 16 0z" fill="#4e9f50"/>
          <circle cx="16" cy="15" r="7" fill="#fff"/>
        </svg>
      `,
      iconSize: [32, 44],
      iconAnchor: [16, 44],
      popupAnchor: [0, -44],
    });

    // Marker with popup
    L.marker([lat, lng], { icon: greenIcon })
      .addTo(map)
      .bindPopup(
        '<strong>Aksel Benzin A/S</strong><br>Sandtoften 10<br>DK-2820 Gentofte',
        { offset: [0, 4] }
      );
  });
}